'use strict';

var React = require('react');

var SvgUndoMajor = function SvgUndoMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.488 5c2.149-1.934 3.99-3 6.512-3a8 8 0 0 1 8 8 8 8 0 0 1-8 8 1 1 0 1 0 0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10c-3.297 0-5.644 1.496-8 3.647v-2.647a1 1 0 0 0-2 0v5a.998.998 0 0 0 1 1h5a1 1 0 0 0 0-2h-2.512z"
  }));
};

exports.SvgUndoMajor = SvgUndoMajor;
